export default "__VITE_ASSET__d45e6b8f__"